import { ApplicationDataAPI } from "../common/lib/API/ApplicationDataAPI";
import { DocsDataAPI } from "../common/lib/API/DocsDataAPI";

const ApplicationRepo = {
	// ********** Applicaiton Start *****************************************************************
	async getApplicationCount() {
		let params = { action: "appCount",  is_special: false};
		let apps = await ApplicationDataAPI.fetchApplications(params, "ALL");
		return apps;
	},
	async getApplications(status) {
		let response = await ApplicationDataAPI.fetchApplications(
			{
				status: status,
				application_state: "open",
				is_special: false,
			},
			"ALL"
		);
		return response;
	},
	async getSearchApplications(filterList) {
		let applications = await ApplicationDataAPI.fetchApplications(
			filterList,
			"ALL"
		);
		return applications;
	},
	async getApplicationById(appId) {
		let app = await ApplicationDataAPI.fetchApplicationById(appId, "ALL");
		return app;
	},
	async getApplicationDocuments(app) {
		let documents = await ApplicationDataAPI.fetchApplicationDocumentsById(
			app.id,
			app.broker_id
		);
		return documents;
	},
	async getDocumentInfo(documentId) {
		let documents = await DocsDataAPI.getDocumentAttachment(documentId);
		return documents;
	},
	async postDocument(documentInfo, broker_id) {
		let documents = await DocsDataAPI.postDocument(documentInfo, broker_id);
		return documents;
	},
	async postAttachment(attachmentInfo) {
		let documents = await DocsDataAPI.postAttachment(attachmentInfo);
		return documents;
	},
	async submitApplication(app, action) {
		const response = await ApplicationDataAPI.updateApplicationWithAction(
			app,
			{
				action: action,
			},
			app.broker_id
		);
		return response;
	},
	async updateApplicaiton(app) {
		await ApplicationDataAPI.updateApplication(app, "ALL");
	},

	async rejectApplicaiton(app) {
		const params = {
			action: "reject",
		};
		const response = await ApplicationDataAPI.updateApplicationWithAction(
			app,
			params,
			"ALL"
		);
		return response;
	},

	async holdApplicaiton(app) {
		let params = { action: "hold" };
		await ApplicationDataAPI.updateApplicationWithAction(app, params, "ALL");
	},
	async unholdApplication(app) {
		let params = { action: "unhold" };
		await ApplicationDataAPI.updateApplicationWithAction(app, params, "ALL");
	},
	// ********** Applicaiton end *******************************************************************

	// ********** Applicaiton guarantor - Start *****************************************************
	async getApplicationGuarantors(appId) {
		let guarantors = await ApplicationDataAPI.fetchApplicationGuarantorsById(
			appId,
			"ALL"
		);
		return guarantors;
	},
	// ********** Applicaiton guarantor - end *******************************************************

	// ********** Applicaiton asset - Start *********************************************************
	async getApplicationAssets(appId) {
		let assets = await ApplicationDataAPI.fetchApplicationAssetsById(
			appId,
			"ALL"
		);
		return assets;
	},
	// ********** Applicaiton asset - end ***********************************************************

	// ********** Applicaiton fees - Start **********************************************************
	async getApplicationFees(appId) {
		let fees = await ApplicationDataAPI.getApplicationFeesById(appId, "ALL");
		return fees;
	},
	// ********** Applicaiton fees - end ************************************************************

	// ********** Applicaiton documents - Start *****************************************************
	async getApplicationDocs(appId) {
		let docs = await ApplicationDataAPI.fetchApplicationDocumentsById(
			appId,
			"ALL"
		);
		return docs;
	},

	async saveApplicationDocForLessee(
		appId,
		fileName,
		fileType,
		azure_file_url,
		rfiID
	) {
		const document = {
			application_id: appId,
			document_name: fileName,
			type: fileType,
			related_to: "Lessee",
			notes: "File uploaded from container",
			azure_file_url: azure_file_url,
			rfi: rfiID,
		};

		let documentId = await DocsDataAPI.postDocument(document, "ALL");
		return documentId;
	},
	// ********** Applicaiton documents - End ******************************************************

	// ********** Applicaiton notes - Start ********************************************************
	async getApplicationNotes(appId) {
		let notes = await ApplicationDataAPI.fetchApplicationNotesById(appId, "All");
		return notes;
	},

	async saveApplicationNote(note) {
		let noteId = await ApplicationDataAPI.postNote(note, "ALL");
		return noteId;
	},
	// ********** Applicaiton notes - End **********************************************************

	// ********** Applicaiton deals - Start *********************************************************
	async getApplicationDeals(appId) {
		let deals = await DocsDataAPI.fetchApplicationDealsById(appId, "All");
		return deals;
	},
	// ********** Applicaiton deals - end ***********************************************************
	async deleteApplicationNote(noteId) {
		let note = await ApplicationDataAPI.deleteNote(noteId);
		return note;
	},
	// ********** Applicaiton rfi - Start **********************************************************
	async getApplicationRfis(appId) {
		let rfis = await ApplicationDataAPI.fetchApplicationRfisById(appId, "ALL");
		return rfis;
	},
	async getApplicationStatusCodes() {
		const response = await ApplicationDataAPI.getApplicationStatusCodes();
		return response;
	},
	// ********** Applicaiton rfi - end ************************************************************
	// ********** Applicaiton end *******************************************************************
};

export default ApplicationRepo;
